import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';
import { buildListParams } from '../../dataHandlers/queryParams';
import { parseListResponse } from '../../dataHandlers/parseListResponse';

const fetchMeters = async (query) => {
  const { data } = await apiClient.get('/meters', { params: query.queryKey[1] });
  return data;
};

export const useGetMetersHandler = ({ searchQuery = {} }) => {
  const dispatch = useDispatch();
  const [meters, setMeters] = useState([]);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const listParams = buildListParams(searchQuery);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['meters', listParams],
    queryFn: fetchMeters,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    cacheTime: 0,
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      const { rows, total } = parseListResponse(fetchedData);
      setMeters(rows);
      setTotalDocuments(total);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (!isError) return;
    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      return;
    }
    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return { meters, totalDocuments, isLoading };
};
